import React, { useState } from "react";
import { ShieldCheck, AlertTriangle, XCircle, ChevronDown } from "lucide-react";
import { useCad } from "../context/CadContext";
import { inspectAssembly } from "../lib/inspect";

export function AssemblyInspector() {
  const { layers, settings, base, setSelectedId } = useCad();
  const [open, setOpen] = useState(true);
  const { ok, items } = inspectAssembly(layers, settings, !!base);
  const errors = items.filter((i) => i.level === "error").length;
  const warns = items.filter((i) => i.level === "warn").length;

  return (
    <div className="border-b border-slate-800">
      <button
        data-testid="assembly-inspector-toggle"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center gap-2 px-3 py-2.5 hover:bg-slate-800/40 transition-colors duration-150"
      >
        {items.length === 0 ? (
          <ShieldCheck size={13} className="text-emerald-400" />
        ) : errors > 0 ? (
          <XCircle size={13} className="text-rose-400" />
        ) : (
          <AlertTriangle size={13} className="text-amber-400" />
        )}
        <span className="text-[11px] font-mono uppercase tracking-widest text-slate-400">Assembly Inspector</span>
        <span className="ml-auto flex items-center gap-1.5 text-[10px] font-mono">
          {errors > 0 && <span className="text-rose-400">{errors} err</span>}
          {warns > 0 && <span className="text-amber-400">{warns} warn</span>}
          {items.length === 0 && <span className="text-emerald-400">clear</span>}
          <ChevronDown size={12} className={`text-slate-500 transition-transform ${open ? "" : "-rotate-90"}`} />
        </span>
      </button>
      {open && (
        <div data-testid="assembly-inspector-list" className="px-3 pb-3 space-y-1.5 max-h-40 overflow-y-auto cad-scroll">
          {items.length === 0 ? (
            <div className="text-[11px] text-emerald-400/80 flex items-center gap-1.5">
              <ShieldCheck size={12} /> All connectors validated — ready to export.
            </div>
          ) : (
            items.map((it, i) => (
              <button
                key={i}
                onClick={() => it.plateId && setSelectedId(it.plateId)}
                className="w-full text-left flex items-start gap-2 text-[11px] leading-snug rounded-md px-2 py-1.5 bg-slate-950/40 hover:bg-slate-800/60 transition-colors duration-150"
              >
                {it.level === "error" ? (
                  <XCircle size={12} className="text-rose-400 mt-0.5 shrink-0" />
                ) : (
                  <AlertTriangle size={12} className="text-amber-400 mt-0.5 shrink-0" />
                )}
                <span className="text-slate-300">{it.msg}</span>
              </button>
            ))
          )}
        </div>
      )}
    </div>
  );
}
